import { runAfterBootstrap } from 'owa-delayed-initialization';
import initCalendarProcessingOptions from './utils/initCalendarProcessingOptions';
// Load initial state needed for options
runAfterBootstrap(function () {
    initCalendarProcessingOptions();
});
export { default as getCalendarOptions } from './utils/getCalendarOptions';
export { default as initCalendarProcessingOptions } from './utils/initCalendarProcessingOptions';
export { default as saveCalendarProcessingOptions, } from './orchestrators/saveCalendarProcessingOptions';
export { default as updateCalendarProcessingOptions, } from './actions/updateCalendarProcessingOptions';
//# sourceMappingURL=index.js.map